import Vue from 'vue';
import VueResource from 'vue-resource';
import router from '@/router';

Vue.use(VueResource);

export const fncPopulateProjectList = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.projectList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true)) || (payload != undefined && (payload.refresh == true || payload.refresh == true))) {
    if( router.history.current.query.manufacturer != null ) {
      var userDetails = { id: 0, manufacturer: router.history.current.query.manufacturer };
    } else {
      var objAuth = JSON.parse(rootState.objAuthorize);
      var userDetails = { id: objAuth.id, manufacturer: objAuth.manufacturer };
    }

		var params = { a: 'get_projects', user: userDetails };
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Project.php', { params: params }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project list', display: true };
				commit('setSnack', snackDetails);
			}).then(data => {

				commit('setProjectList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Projects reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
	}
}

export const fncDeleteProject = ({commit, dispatch, state, rootState}, payload) => {
	var projectDetails = {id: payload.projectId};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=delete', projectDetails, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to remove the project', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
			var snackDetails = {color: 'success', message: 'The project was removed successfully', display: true};
			commit('setSnack', snackDetails);
			commit('setProjectList', '');
			dispatch('fncPopulateProjectList');
    });
}

export const fncPopulateProjectStatusList = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.projectStatusList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var projectDetails = { manufacturer: objAuth.manufacturer };
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProjectStatus.php?a=retrieve', { params: projectDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project statusses', display: true };
				commit('setSnack', snackDetails);
			}).then(data => {
				for (var n = 0; n < data.length; n++) {
					data[n].order = parseInt(n) + 1;
				}
				commit('setProjectStatusList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Project Stats reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
	}
}

export const fncPopulateProjectSpecifiers = ({commit, dispatch, state, rootState}) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var specifierDetails = {manufacturer: objAuth.manufacturer};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=get_specifiers', {params: specifierDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
        	commit('setProjectSpecifiers', data);
    	});
}

export const fncPopulateProjectVehicles = ({commit, dispatch, state, rootState}) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var vehicleDetails = {id: "null", manufacturer: objAuth.manufacturer};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=get_prj_vehicles', {params: vehicleDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
        	commit('setProjectVehicles', data);
    	});
}

export const fncUploadProjectImage = ({ commit, dispatch, state, rootState }, payload) => {
	var uploadData = new FormData();
	var randInt = Math.floor((Math.random() * 9999) + 1000);
    uploadData.append('imgPrefix', randInt);
    uploadData.append('projectImage', payload, payload.name);
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=upload_image', uploadData, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true};
            commit('setSnack', snackDetails);
		}).then(data => {
        	commit('setProjectImage', data);
        	//commit('setProjectVehicles', data);
    });
}

export const fncUploadEditProjectImage = ({ commit, dispatch, state, rootState }, payload) => {
	var uploadData = new FormData();
	var randInt = Math.floor((Math.random() * 9999) + 1000);
	uploadData.append('imgPrefix', randInt);
	uploadData.append('projectImage', payload, payload.name);
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=upload_image', uploadData, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			commit('setEditProjectImage', data);
			//commit('setProjectVehicles', data);
		});
}

export const fncDeleteProjectStatus = ({commit, dispatch, state, rootState}, payload) => {
    var statusDetails = {id:payload.statusId};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProjectStatus.php?a=delete', {params: statusDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error occured while trying to remove the project status', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
            var snackDetails = {color: 'success', message: 'The project status was successfully deleted', display: true};
            commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateProjectStatusList',
				refresh: true
			});
    });
}

export const fncAddProjectStatus = ({commit, dispatch, state, rootState}, payload) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var statusDetails = {description: payload.statusDescription, order: '99', tender_winning: payload.tenderWinning, manufacturer: objAuth.manufacturer};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProjectStatus.php?a=create', {params: statusDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occurred while trying to add the project status', display: true};
            commit('setSnack', snackDetails);
        }).then(data => {
        var snackDetails = {color: 'success', message: 'The project status has successfully been added', display: true};
        commit('setSnack', snackDetails);
		dispatch({
			type: 'fncPopulateProjectStatusList',
            refresh: true
		});
        commit('hideModal');
    });
}

export const fncEditProjectStatus = ({commit, dispatch, state, rootState}, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var tenderWinning = payload.statusObj.obj.tender_winning === false ? 0 : 1;
	var statusDetails = { id: payload.statusObj.obj.id, description: payload.statusObj.obj.description, order: payload.statusObj.obj.order, tender_winning: tenderWinning, manufacturer: objAuth.manufacturer };
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'ProjectStatus.php?a=edit', {params: statusDetails}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occurred while trying to update the project status', display: true};
            commit('setSnack', snackDetails);
		}).then(data => {
			if (payload.reload == undefined) {
				var snackDetails = { color: 'success', message: 'The project status has successfully been updated', display: true };
				commit('setSnack', snackDetails);
				commit('hideModal');
				dispatch({
					type: 'fncPopulateProjectStatusList',
					refresh: true
				});
			}
    });
}

export const fncReorderProjectStatus = ({ commit, dispatch, state, rootState }, payload) => {
	commit({
		type: 'fncResetProjectStatus',
		newIndex: payload.end,
		oldIndex: payload.start
	});
	for (var k in state.projectStatusList) {
		dispatch({
			type: 'fncEditProjectStatus',
			statusObj: state.projectStatusList[k],
			reload: false
		});
	}
	commit('fncSetProjectStatus', state.projectStatusList);
	dispatch({
		type: 'fncPopulateProjectStatusList',
        refresh: true
	});
	var snackDetails = { color: 'success', message: 'The project status order was updated successfully', display: true };
	commit('setSnack', snackDetails);
}

export const fncPopulateProjectRegions = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var locationDetails = {
		manufacturer: objAuth.manufacturer
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'location_tree_da.php?a=expand_location_tree&manufacturer=' + objAuth.manufacturer + '&parent=0', { params: locationDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while retrieving the region list', display: true };
		}).then(data => {
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=get_all', { params: locationDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the project locations', display: true };
					commit('setSnack', snackDetails);
					commit('hideModal');
				}).then(dd => {
					dd.Country = data;
					commit('setProjectRegions', dd);
				});
		});
	/*Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Location.php?a=get_all', { params: locationDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the project locations', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		}).then(data => {
            console.log( data )
			commit('setProjectRegions', data);
		});	*/
}

export const fncPopulateProjectPreLocations = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var locationDetails = {
		manufacturer: objAuth.manufacturer
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=get_del_loc', { params: locationDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'There has been an error trying to retrieve the project prepopulated locations', display: true };
		}).then(data => {
			commit('setProjectPreLocations', data);
		});
}

export const fncSetRegionSub = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionDetails = { manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'location_tree_da.php?a=expand_location_tree&manufacturer=' + objAuth.manufacturer + '&parent=' + payload, { params: regionDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while retrieving the region list', display: true };
		}).then(data => {
			commit('setProjectRegionSub', data);
		});
}

export const fncSetRegionSubSub = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var regionDetails = { manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'location_tree_da.php?a=expand_location_tree&manufacturer=' + objAuth.manufacturer + '&parent=' + payload, { params: regionDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while retrieving the region list', display: true };
		}).then(data => {
			commit('setProjectRegionSubSub', data);
		});
}

export const fncCreateProject = ({ commit, dispatch, state, rootState }, payload) => {
	for (var k in payload.addresses) {
		if (payload.addresses[k].regions.province.id == undefined || payload.addresses[k].regions.province.id == 'undefined') {
			payload.addresses[k].regions.province.id = 0;
			payload.addresses[k].regions.province.name = '';
		}
		if (payload.addresses[k].regions.district.id == undefined || payload.addresses[k].regions.district.id == 'undefined') {
			payload.addresses[k].regions.district.id = 0;
			payload.addresses[k].regions.district.name = '';
		}
		if (payload.addresses[k].regions.town.id == undefined || payload.addresses[k].regions.town.id == 'undefined') {
			payload.addresses[k].regions.town.id = 0;
			payload.addresses[k].regions.town.name = '';
		}
	}
	var objAuth = JSON.parse(rootState.objAuthorize);
	var projectVehicles = [];
	for ( var k in payload.vehicles ) {
		if (payload.vehicles[k].isChecked == true) {
			projectVehicles.push(payload.vehicles[k].id);
		}
	}
	var closingDate = String(payload.tenderClosingDate);
	var projectDetails = {
		current_user: objAuth.id,
		manufacturer: objAuth.manufacturer,
		name: payload.name,
		code: payload.code,
		type: payload.projectType,
		specifier: payload.specifier,
		specifier_type: payload.specifierType,
		incl_tender: payload.inclTender == true ? 1 : 0,
		notes: payload.notes,
		site_details: payload.siteDetails,
		contact_details: payload.contactDetails,
		tender_closing_date: closingDate.replace(/-/g, "/"),
		reference: payload.reference,
		addresses: payload.addresses,
		prj_veh: projectVehicles,
        status: payload.status
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=create', { params: projectDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to add the project', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if (data.id != undefined || data.id != 'undefined') {
				for (var k in payload.projectImages) {
					var params = { project: data.id, url: payload.projectImages[k].source, caption: payload.projectImages[k].caption };
					Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=add_image', { params: params }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = { color: 'error', message: 'An error occured while trying to add the image to the project', display: true };
							commit('setSnack', snackDetails);
						}).then(data => {
						});
				}
        if (payload.is_new_lead_project){

          var objAuth = JSON.parse(rootState.objAuthorize);
          var userDetails = { id: objAuth.id, manufacturer: objAuth.manufacturer };
          var params = { a: 'get_projects', user: userDetails };
          Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Project.php', { params: params }, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              console.log()
            }).then(data => {
            commit('setProjectList', data);
          });

          var snackDetails = { color: 'success', message: 'The project has successfully been added', display: true };
          commit('setSnack', snackDetails);
          commit('selectedNewLeadProject', data.id)

        }
        else{
          var snackDetails = { color: 'success', message: 'The project has successfully been added', display: true };
          commit('setSnack', snackDetails);
          commit('hideModal');
          commit('setProjectList', '');
          dispatch({
            type: 'fncPopulateProjectList',
            refresh: true
          })
        }

			} else {
				var snackDetails = { color: 'error', message: 'An error occured while trying to add the project', display: true };
				commit('setSnack', snackDetails);
			}
		});
}

export const fncSetProjectEdit = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	payload.incl_tender = payload.incl_tender == 1 ? true : false;
	payload.type = parseInt(payload.type);
	var vehicleDetails = { id: payload.id, manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vehicle.php?a=get_prj_vehicles', { params: vehicleDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			for ( var k in data ) {
				data[k].excluded = data[k].excluded == '1' ? true : false;
			}
			payload.prj_vehicles = data;
			var projectDetails = { project: payload.id };
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=get_images', { params: projectDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true };
					commit('setSnack', snackDetails);
				}).then(i => {
					payload.images = i;
					Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=get_delivery_addresses', { params: projectDetails }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true };
							commit('setSnack', snackDetails);
						}).then(a => {
							payload.addresses = a;
							var quoteDetails = { manufacturer: objAuth.manufacturer, user: objAuth.id, project: payload.id };
							Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getAll', { filter_params: quoteDetails }, rootState.headerDetails)
								.then(response => {
									return response.json();
								}, error => {
									var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the project specifiers', display: true };
									commit('setSnack', snackDetails);
								}).then(q => {
									payload.quotes = q;
									commit('setObjProjectEdit', payload);
									var modalDetails = { title: 'Edit Project - ' + payload.name, component: 'modal-project-edit', mstate: true, params: { projectId: payload.id } };
									commit({
										type: 'setModal',
										details: modalDetails
									});
								});
						});
				});
		});
}

export const fncUpdateProject = ({ commit, dispatch, state, rootState }, payload) => {
	var specifierType = '';
	for (var k in state.projectSpecifiers ) {
		if (state.projectSpecifiers[k].id == payload.editObj.specifier ) {
			specifierType = state.projectSpecifiers[k].type;
		}
	}
	for (var k in payload.addresses) {
		if (payload.addresses[k].regions.province.id == undefined || payload.addresses[k].regions.province.id == 'undefined') {
			payload.addresses[k].regions.province.id = 0;
			payload.addresses[k].regions.province.name = '';
		}
		if (payload.addresses[k].regions.district.id == undefined || payload.addresses[k].regions.district.id == 'undefined') {
			payload.addresses[k].regions.district.id = 0;
			payload.addresses[k].regions.district.name = '';
		}
		if (payload.addresses[k].regions.town.id == undefined || payload.addresses[k].regions.town.id == 'undefined') {
			payload.addresses[k].regions.town.id = 0;
			payload.addresses[k].regions.town.name = '';
		}
	}
	var objAuth = JSON.parse(rootState.objAuthorize);
	var projectVehicles = [];
	for (var k in payload.editObj.prj_vehicles) {
		if (payload.editObj.prj_vehicles[k].excluded == true) {
			projectVehicles.push(payload.editObj.prj_vehicles[k].id);
		}
	}
	var closingDate = String(payload.editObj.tender_closing_date);
	var projectDetails = {
		id: payload.editObj.id,
		params: {
			current_user: objAuth.id,
			manufacturer: objAuth.manufacturer,
			name: payload.editObj.name,
			code: payload.editObj.code,
			type: payload.editObj.type,
			specifier: payload.editObj.specifier,
			specifier_type: specifierType,
			incl_tender: payload.editObj.incl_tender == true ? 1 : 0,
			notes: payload.editObj.notes,
			site_details: payload.editObj.site_details,
			contact_details: payload.editObj.contact_details,
			tender_closing_date: closingDate.replace(/-/g, "/"),
			reference: payload.editObj.reference,
			addresses: payload.addresses,
			prj_veh: projectVehicles,
			status: payload.editObj.status
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=edit', projectDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to update the project', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if (data.id != undefined || data.id != 'undefined') {
				for (var k in payload.images) {
					var params = { project: data.id, url: payload.images[k].src, caption: payload.images[k].caption };
					Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Project.php?a=add_image', { params: params }, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = { color: 'error', message: 'An error occured while trying to add the image to the project', display: true };
							commit('setSnack', snackDetails);
						}).then(d => {
						});
				}
				var snackDetails = { color: 'success', message: 'The project has successfully been updated', display: true };
				commit('setSnack', snackDetails);
				commit('hideModal');
				commit('setProjectList', '');
				dispatch({
					type: 'fncPopulateProjectList',
					refresh: true
				})
			} else {
				var snackDetails = { color: 'error', message: 'An error occured while trying to update the project', display: true };
				commit('setSnack', snackDetails);
			}
		});
}

export const fncCancelAdjudication = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var projectDetails = { id: payload };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=prj_cancel_adjudication', { params: projectDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while cancelling the tender adjudication', display: true };
		}).then(data => {
			if (data == null) {
				var snackDetails = { color: 'success', message: 'The project adjudication has been successfully cancelled', display: true };
				commit('setSnack', snackDetails);
			}
		});
}

export const fncQuoteAsWinner = ({ commit, dispatch, state, rootState }, payload) => {
	var quoteDetails = { id: payload.quoteId };
	var quotePayload = [];
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getQuote', quoteDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while retrieving the quote content', display: true };
		}).then(data => {
			quotePayload.quote = data;
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getContent', quoteDetails, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error occured while retrieving the quote content', display: true };
				}).then(d => {
					for ( var k in d ) {
						d[k].winning = false;
					}
					quotePayload.content = d;
					commit('setProjectTenderWinner', quotePayload);
					var modalDetails = { title: 'Edit Project Quote', component: 'modal-project-quote-details', mstate: true, params: { projectId: payload.projectId } };
					commit({
						type: 'setModal',
						details: modalDetails
					});
				});
		});
}

export const fncUpdateProjectQuote = ({ commit, dispatch, state, rootState }, payload) => {
	var winItems = [];
	for (var k in payload.items) {
		if ( payload.items[k].winning == true ) {
			winItems.push(payload.items[k].id);
		}
	}
	var projectDetails = {
		params: {
			quote: state.projectTenderWinner.quote.id,
			project: payload.projectId,
			winning: 1,
			items: winItems
		}
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=flag_winning_quote', projectDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while retrieving the quote content', display: true };
		}).then(data => {
			var snackDetails = { color: 'success', message: 'The project quote has successfully been updated', display: true };
			commit('setSnack', snackDetails);
			commit('hideModal');
		});
}
